import { Button, ButtonSize, ButtonType, ButtonVariant, Caption } from 'components/core';
import { OUTLINE_SMALL } from './buttonProps';

export interface StepInfo {
  id: string;
  title: string;
  /** The step is answered, so the next one can be opened. */
  done: boolean;
}

interface BuilderStepNavProps {
  steps: StepInfo[];
  current: number;
  onGo: (index: number) => void;
}


/** A step can be opened when every step before it is answered. */
const reachable = (steps: StepInfo[], index: number): boolean => steps.slice(0, index).every((s) => s.done);

// Where the admin is in the questions, with a way to go back or move on without scrolling.
export const BuilderStepNav = ({ steps, current, onGo }: BuilderStepNavProps) => (
  <div className="mb-4">
    <div className="d-flex flex-wrap gap-2 mb-2">
      {steps.map((s, i) => (
        <Button htmlType="button"
          key={s.id}
          size={ButtonSize.small}
          type={ButtonType.secondary}
          variant={i === current ? ButtonVariant.contained : ButtonVariant.outline}
          disabled={i !== current && !reachable(steps, i)}
          onClick={() => onGo(i)}
        >
          {`${i + 1}. ${s.title}`}
        </Button>
      ))}
    </div>
    <Caption text={`Step ${current + 1} of ${steps.length}: ${steps[current].title}`} />
  </div>
);

interface StepButtonsProps {
  steps: StepInfo[];
  current: number;
  onGo: (index: number) => void;
}

// Back and Next under the step; Next waits until the step is answered.
export const StepButtons = ({ steps, current, onGo }: StepButtonsProps) => {
  const last = current === steps.length - 1;
  return (
    <div className="d-flex justify-content-between mb-4">
      <div>
        {current > 0 && (
          <Button {...OUTLINE_SMALL} onClick={() => onGo(current - 1)}>
            Back
          </Button>
        )}
      </div>
      {!last && (
        <Button htmlType="button" size={ButtonSize.small} type={ButtonType.primary} variant={ButtonVariant.contained} disabled={!steps[current].done} onClick={() => onGo(current + 1)}>
          {`Next: ${steps[current + 1].title}`}
        </Button>
      )}
    </div>
  );
};
